import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { LoadOptions } from 'devextreme/data/load_options';
import { utc } from 'moment';
import moment from 'moment/moment';
import { BehaviorSubject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { DxCellPreparedEvent, DxToolbarPreparingEvent } from '../../../../core/dx.types';
import { MongoLoadOptionsConverter } from '../../../../shared/classes/loopback-custom-store/generic/load-options-converters/MongoLoadOptionsConverter';
import { LoopBackStoreOptions } from '../../../../shared/classes/loopback-custom-store/generic/store-options/LoopBackStoreOptions';
import {
  gqlMongoByKey,
  gqlMongoCount,
  gqlMongoLoad,
  gqlMongoStore,
} from '../../../../shared/classes/loopback-custom-store/generic/store.utils';
import { hAll, headersAllTenantsAppend } from '../../../../shared/classes/utils/utils';
import { CommonService } from '../../../../shared/modules/my-common/services/common.service';
import { ConfigService } from '../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { StateStoreService } from '../../../../shared/modules/my-common/services/state-store.service';
import { ABaseComponent } from '../../../../shared/modules/ui/components/abstract/a-base.component';
import { GridHelperService } from '../../../../shared/modules/ui/services/grid-helper.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { AuthService, AuthServiceApi, Consumer, Facility, LoggerService } from '../../../../shared/sdk';
import { HelperService as ConsumerHelperService } from '../../../consumer/services/helper.service';
import { AuthClaimService } from '../../services/auth-claim.service';

@Component({
  selector: 'app-unassigned-clients',
  templateUrl: './unassigned-clients.component.html',
  styleUrls: ['./unassigned-clients.component.scss'],
  providers: [AuthClaimService],
})
export class UnassignedClientsComponent extends ABaseComponent implements OnInit {
  $filterEvent$: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  @ViewChild('grid', { static: true }) grid: DxDataGridComponent;

  grid_stateStoring: any;
  grid_detail_stateStoring: any;

  dso: DataSourceOptions;

  facilityDso: DataSourceOptions = [];
  consumerDso: DataSourceOptions = [];

  selectedDateValue?: Date; // = new Date();
  selectedCodes: any[] = ['W1759', 'W1760', 'W1761', 'W1762', 'W1764'];

  clientDso = {};

  codeDso: any;

  gridFilterValue: any;

  constructor(
    public logger: LoggerService,
    public config: ConfigService,
    public common: CommonService,
    private ui: UiService,
    private sss: StateStoreService,
    private dss: DataSourceService,
    private gridHelper: GridHelperService,
    public consumerHelper: ConsumerHelperService,
    protected dialog: MatDialog,
    private service: AuthClaimService,
  ) {
    super(logger);

    this.grid_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: '23a5a936-1778-42c0-b400-adda341ce8c3',
    };

    this.grid_detail_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: '1f659f0e-fe27-4a3c-8cea-5861d56d71ea',
    };
  }

  ngOnInit() {
    super.ngOnInit();

    this.dso = this.buildDataSource();

    this.facilityDso = this.buildFacilityDataSource();
    this.consumerDso = this.buildConsumerDataSource();

    this.codeDso = this.service.buildCodeDso(this.dss);

    this.$filterEvent$
      .pipe(
        tap(() => {
          this.ui.showLoading();
        }),
        switchMap(async () => (this.dso = this.buildDataSource())),
        tap(() => {
          this.ui.hideLoading();
        }),
        takeUntil(this.$onDestroy$),
      )
      .subscribe();
  }

  private buildDataSource() {
    const self = this;

    const activeAuthUtc =
      this.selectedDateValue && moment(this.selectedDateValue).isValid()
        ? utc(moment(this.selectedDateValue).format('YYYY-MM-DD'))
        : utc(moment().subtract(1, 'month').format('YYYY-MM-DD'));

    // const col = 'ExportsConsumersCache';
    // const aggregate = [
    //   {
    //     $match: {
    //       _broker: 'NAVINET.AUTH',
    //     },
    //   },
    // ];

    const som = activeAuthUtc.clone().startOf('month');
    const sonm = som.clone().add(1, 'month');

    const col = 'ExportsAuthsDataCache';
    const aggregate = [
      {
        $match: {
          StartDT: { $lt: { $date: { v: sonm.toISOString() } } },
          EndDT: { $gte: { $date: { v: som.toISOString() } } },
          ...(this.selectedCodes.length > 0
            ? {
                Code: { $in: this.selectedCodes },
              }
            : {}),
          _inactive: { $ne: true },
          // _valid: true,
          //
          _tenantId: null,
        },
      },
      { $project: { _source: 0 } },
      {
        $sort: {
          StartDT: -1,
          _ctime: -1,
        },
      },
      {
        $group: {
          _id: {
            _broker: '$_broker',
            _clientId: '$_clientId',
          },
          // docs: {
          //   $push: '$$CURRENT',
          // },
          last: {
            $first: '$$CURRENT',
          },
        },
      },
      {
        $sort: {
          'last.StartDT': -1,
          'last._ctime': -1,
        },
      },
    ];

    const store = gqlMongoStore(self.dss, col, aggregate, {
      update: async (key: any | string | number, values: any): Promise<any> => {
        // console.log(key, values);

        await this.dss
          .getApi<AuthServiceApi>(AuthService)
          .assignSystemClientToAuthOne(key._broker, key._clientId, values.last._tenantId, hAll)
          .toPromise();
      },
    });

    const dso: DataSourceOptions = {
      store,
      // sort: [{selector: '_date', desc: true}],
      // postProcess: (data: Array<any>): Array<any> => {
      //   return data;
      // },
    } as DataSourceOptions;
    return dso;
  }

  getClientAuthsDso(authDoc) {
    const self = this;

    if (!this.clientDso[authDoc._clientId]) {
      const col = 'ExportsAuthsDataCache';
      const aggregate = [
        {
          $match: {
            _inactive: { $ne: true },
            // _valid: true,
            _clientId: authDoc._clientId,
          },
        },
        { $project: { _source: 0 } },
        {
          $sort: {
            StartDT: -1,
            _ctime: -1,
          },
        },
      ];

      const store = gqlMongoStore(self.dss, col, aggregate);

      const dso: DataSourceOptions = {
        store,
        // sort: [{selector: '_date', desc: true}],
        // postProcess: (data: Array<any>): Array<any> => {
        //   return data;
        // },
      } as DataSourceOptions;

      this.clientDso[authDoc._clientId] = dso;
    }

    return this.clientDso[authDoc._clientId];
  }

  private buildFacilityDataSource() {
    const so = this.dss.getStoreOptions(Facility, undefined, false);
    so.customFilter = {
      where: { type: { inq: ['MEALS'] } },
      order: ['typeOrder DESC', 'type', 'shortname'],
    };

    const dso: DataSourceOptions = {
      store: new CustomStore(so),
    } as DataSourceOptions;
    return dso;
  }

  private buildConsumerDataSource() {
    const so = this.dss.getStoreOptions(Consumer, undefined, false) as LoopBackStoreOptions<any, any>;
    // so.customHeaders = hTenant(oc(this.facilityId)(-1));
    so.customHeaders = headersAllTenantsAppend;

    const dso: DataSourceOptions = {
      store: new CustomStore(so),
    } as DataSourceOptions;

    return dso;
  }

  filter() {
    this.$filterEvent$.next(true);
  }

  grid_onInitialized(e) {
    this.gridHelper.handle(e.component, {
      flatToTreeObject: false,
      copyIdsOnSaving: false,
      selectRowOnEdit: false,
      notifyErrors: true,
    });
  }

  grid_onToolbarPreparing(e: DxToolbarPreparingEvent) {}

  grid_onContextMenuPreparing(e) {}

  grid_onCellPrepared(e: DxCellPreparedEvent) {}

  grid_detail_onCellPrepared(e: DxCellPreparedEvent, docs: any[]) {
    if (e.rowType === 'data' && e.data._valid === false) {
      if (e.data._invalidObj[e.column.dataField]) e.cellElement.style.background = 'lightsalmon';
    }
  }

  tenantDropDown_onValueChanged(cellInfo, e) {
    cellInfo.setValue(e.value);
  }
}
